/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.ConfirmRespondentAction.CONFIRM_RESPONDENT:
      return {
        ...state,
    };
    case actions.ConfirmRespondentAction.CONFIRM_RESPONDENT_RESPONSE:
          return{
      ...state,
    };

    default:
      return state;
  }
};

export default reducer;
